import Konva from 'konva';
import React, { useRef } from 'react';
import { Image as KonvaImage } from 'react-konva';
import useImage from 'use-image';

interface ImageProps {
  url: string;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
}

const SlideImage = ({ url, x, y, width, height, rotation }: ImageProps) => {
  const [image, status] = useImage(url);
  const imageRef = useRef<Konva.Image>(null);

  if (status !== 'loaded') {
    return null;
  }

  return (
    <KonvaImage
      ref={imageRef}
      image={image}
      x={x}
      y={y}
      width={width}
      height={height}
      rotation={rotation}
    />
  );
};

export default SlideImage;
